import { render, staticRenderFns } from "./SummaryModal.vue?vue&type=template&id=67f4a3cf&scoped=true&"
import script from "./SummaryModal.vue?vue&type=script&lang=ts&"
export * from "./SummaryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f4a3cf",
  null
  
)

export default component.exports